import React, { Component } from 'react'
import Edit from '../assets/edit.svg'
import specialcustomer from '../assets/specialcustomer.svg'
import {OverlayTrigger,Tooltip} from 'react-bootstrap'

export default class EditButton extends Component {
    render() {
        return (
            

            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 200, hide: 200 }}
                    overlay={<Tooltip style={{fontFamily:'SFUIDisplay',fontSize:'12px'}}>ویرایش</Tooltip>}
                >
                    <div style={{cursor:'pointer',userSelect:'none'}} onClick={() => this.props.editItem(this.props.value)}>
                        <img src={Edit} alt="" style={{objectFit: 'contain',height:'20px'}} />
                    </div>
                </OverlayTrigger>
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 200, hide: 200 }}
                    overlay={<Tooltip style={{fontFamily:'SFUIDisplay',fontSize:'12px'}}>گزارش مشترکین خاص</Tooltip>}
                >
                    <div style={{cursor:'pointer',userSelect:'none',marginRight:'20px'}} onClick={() => this.props.reportSpecialCustomer(this.props.value,null,null,1)}>
                        <img src={specialcustomer} alt="" style={{objectFit: 'contain',height:'25px'}} />
                    </div>
                </OverlayTrigger>
                
            </div>
        )
    }
}
